import { useQueryClient } from '@tanstack/react-query';

import { markAllNotificationsRead } from '../../api/notifications.api';
import useMutation from '../base/useMutation';
import { queryKeys } from '../../queryKeys';

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => markAllNotificationsRead(),
    onSuccess: () => {
      queryClient.setQueryData(
        queryKeys.notifications.unreadCount().queryKey,
        0,
      );
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.notifications.fetchInfiniteNotifications._def,
      });
    },
  });
}
